/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/click-events-have-key-events */

/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountCircle } from '@mui/icons-material';
import { Divider, Menu } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Box, List, ListItem, MenuItem } from '/src/components';
import { useUserStore } from '/src/context';

export const ProfileMenu: React.FC = observer(() => {
  /** Context **/
  const userStore = useUserStore();
  const navigate = useNavigate();

  /** State **/
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  /** Methods **/

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const signout = async () => {
    await userStore.signout();

    navigate('/signin');
  };

  /** Render **/
  return (
    <List component="ul" className="float-right">
      <ListItem>
        <a
          id="profile-button"
          aria-label="Options Menu"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <Box component="span" className="pad-right-xs">
            {userStore.user?.displayName}
          </Box>
          <AccountCircle className="material-icons" />
        </a>
        <Menu
          className="md-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          slotProps={{
            list: { 'aria-labelledby': 'profile-button' },
          }}
          md-position-mode="target-right target"
        >
          <Box className={'md-menu-content[width="4"] md-default-theme'}>
            {userStore.isAdmin && (
              <>
                <MenuItem>
                  <button
                    className="md-button md-default-theme"
                    onClick={() => navigate('/bulk')}
                    aria-label="Import/Export Data"
                  >
                    <Box component="span">Import/Export</Box>
                  </button>
                </MenuItem>

                <Divider />

                <MenuItem>
                  <button
                    className="md-button md-default-theme"
                    onClick={() => navigate('/users')}
                    aria-label="User Administration"
                  >
                    <Box component="span">User Administration</Box>
                  </button>
                </MenuItem>

                <Divider />
              </>
            )}
            <MenuItem>
              <button
                className="md-button md-default-theme"
                onClick={() => navigate('/settings/profile')}
                aria-label="Edit Profile"
              >
                <Box component="span">Edit Profile</Box>
              </button>
            </MenuItem>
            {/* {userStore.user?.provider === 'local' && ( */}
            <MenuItem>
              <button
                className="md-button md-default-theme"
                onClick={() => navigate('/settings/password')}
                aria-label="Change Password"
              >
                <Box component="span">Change Password</Box>
              </button>
            </MenuItem>
            {/* )} */}
            <Divider />
            <MenuItem>
              <button className="md-button md-default-theme" onClick={() => signout()} aria-label="Sign Out">
                <Box component="span">Sign Out</Box>
              </button>
            </MenuItem>
          </Box>
        </Menu>
      </ListItem>
    </List>
  );
});
